import { tv } from "../../variants/tv.js";
const disclaimerVariants = tv({
    slots: {
        paragraph: 'overflow-auto leading-normal text-pretty break-words'
    }
});
export { disclaimerVariants };
